// schema
import * as ISchema from "#webapp/src/__schema__";

import { getMomentForSlot, GetMomentForSlotSlot } from "#webapp/src/util/scheduling-slot.util";
import { getRenderTimeZone } from "@clockwise/web-commons/src/util/time-zone.util";

export type GetEventTimeForSchedulingSlot = GetMomentForSlotSlot;
export function getEventTimeForSchedulingSlot(
  schedulingSlot: GetEventTimeForSchedulingSlot,
): ISchema.IEventTimeInput {
  const slotMoment = getMomentForSlot(schedulingSlot);
  return {
    type: "DateTime" as ISchema.EventTimeType,
    millis: slotMoment.valueOf(),
    dateOrDateTime: slotMoment.toISOString(),
    timeZone: getRenderTimeZone(),
    offsetMinutes: slotMoment.utcOffset(),
  };
}
